
const ReservationDetails = ({
  detailsView, closeDetails, isLoadingDetails, parametricIncidentResponsibles, 
  responsible, setResponsible, handleChangeDetailsView, parametricIncidentTypes, 
  setIncidentType, description1, setDescription1, handlePreviewIncident, 
  dataPreviewFinal, description2, setDescription2, resolverAndTerminate, 
  selectedConversation, user, userProfile, isDetailsOpenMobile, className,

  setSupportTargetId,
  setSupportTargetRole,
  setSupportTargetName,
  setShowSupportModal
}: any) => (
  <aside className={`details-panel bg-white flex-col overflow-hidden flex-shrink-0 border-l border-neutral-border flex ${className} ${isDetailsOpenMobile ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}`}>
    {detailsView === "incidentType" && (
      <div className="h-20 px-4 lg:px-8 border-b border-neutral-border flex items-center justify-between">
        <button
          onClick={closeDetails}
          className="lg:hidden w-9 h-9 flex items-center justify-center active:scale-90 transition-transform"
        >
          <span className="material-symbols-outlined text-jom-gray-900">
            close
          </span>
        </button>

        <h3 className="text-[18px] font-semibold text-neutral-text">
          Acciones sobre el incidente
        </h3>

        <div className="w-9 lg:hidden"></div>

      </div>
    )}
    <div className="p-6 overflow-y-auto flex-1">
      {isLoadingDetails ? (
        <div className="flex flex-col gap-4 animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="space-y-3">
            <div className="h-10 bg-gray-200 rounded"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
          <div className="h-24 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>
      ) : (
        <>
          {detailsView === "incidentType" && (
            <div className="flex flex-col gap-6">
              <div>
                <p className="text-sm font-medium text-neutral-text mb-2">
                  Responsable del incidente:
                </p>
                <div className="flex flex-col gap-2">
                  {parametricIncidentResponsibles.map((option: any) => (
                    <label
                      key={option?.responsiblePartyId}
                      className="flex items-center gap-2"
                    >
                      <input
                        type="radio"
                        name="responsible"
                        onChange={() => setResponsible(option)}
                        className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary cursor-pointer"
                      />
                      <span className="text-sm text-neutral-text">
                        {option?.name}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
              {/* <div>
                <p className="text-sm font-medium text-neutral-text mb-2">
                  El caso permite devolución:
                </p>
                <div className="flex flex-col gap-2">
                  {["Si", "No"].map((option) => (
                    <label
                      key={option}
                      className="flex items-center gap-2"
                    >
                      <input
                        type="radio"
                        name="refund"
                        value={option}
                        onChange={() => setAllowsRefund(option === "Si")}
                        className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                      />
                      <span className="text-sm text-neutral-text">
                        {option}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-sm font-medium text-neutral-text mb-2">
                  El caso permite Penalización:
                </p>
                <div className="flex flex-col gap-2">
                  {["Si", "No"].map((option) => (
                    <label
                      key={option}
                      className="flex items-center gap-2"
                    >
                      <input
                        type="radio"
                        name="penalty"
                        value={option}
                        onChange={() => setAppliesPenalty(option === "Si")}
                        className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                      />
                      <span className="text-sm text-neutral-text">
                        {option}
                      </span>
                    </label>
                  ))}
                </div>
              </div> */}
              <button
                className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                onClick={() => handleChangeDetailsView("resumeIncidentType")}
              >
                CONTINUAR
              </button>
            </div>
          )}
          {detailsView === "confirmation3" && (
            <div className="flex flex-col gap-4">
              <div>
                {responsible?.code != "DESIST" && (
                  <p className="text-sm font-medium text-neutral-text mb-2 mt-2">
                    Tipo de incidente:
                  </p>
                )}
                <div className="flex flex-col gap-2">
                  {parametricIncidentTypes.map((option: any) => (
                    <label
                      key={option?.incidentTypeId}
                      className="flex items-center gap-2"
                    >
                      <input
                        type="radio"
                        name="incidentType"
                        onChange={() => setIncidentType(option)}
                        className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary cursor-pointer"
                      />
                      <span className="text-sm text-neutral-text">
                        {option?.name}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
              {responsible?.code == "DESIST" && (
                <div>
                  <p className="text-sm font-semibold text-neutral-text mb-2 mt-2">
                    Se desistio de la cancelacion por:
                  </p>
                </div>
              )}
              <textarea
                className="w-full h-24 px-4 py-2 bg-white border border-neutral-border rounded-md focus:outline-none focus:border-primary text-sm text-neutral-text placeholder:text-neutral-secondary"
                placeholder="Placeholder"
                maxLength={500}
                onChange={(e) => setDescription1(e.target.value)}
              ></textarea>
              <div className="flex justify-between items-center text-sm text-neutral-secondary">
                <span>Introduce una descripción.</span>
                <span>{description1?.length ?? 0}/500</span>
              </div>
              <button
                className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                onClick={() => handlePreviewIncident()}
              >
                CONTINUAR
              </button>
            </div>
          )}

          {/* OCULTADO MOMENTANEAMENTE */}
          {detailsView === "confirmation4" && (
            <div className="flex flex-col gap-4 text-sm text-neutral-text mt-4">
              <div className="flex justify-between ">
                <p className="font-semibold">
                  <span >Reembolso al Huesped: </span>{" "}
                  {dataPreviewFinal?.refundAmount ?? 0}
                </p>
              </div>
              <p className="font-semibold">
                <span >
                  Pago al Anfitrión:
                </span>{" "}
                {dataPreviewFinal?.hostPayoutFinal ?? 0}
              </p>
              <p className="font-semibold">
                <span >
                  Penalización al Anfitrión:
                </span>{" "}
                {dataPreviewFinal?.hostNetAfterPenalty ?? 0}
              </p>
              <textarea
                className="w-full h-24 px-4 py-2 bg-white border border-neutral-border rounded-md focus:outline-none focus:border-primary text-sm text-neutral-text placeholder:text-neutral-secondary"
                placeholder="Placeholder"
                maxLength={500}
                onChange={(e) => setDescription2(e.target.value)}
              ></textarea>
              <div className="flex justify-between items-center text-sm text-neutral-secondary">
                <span>Introduce una descripción.</span>
                <span>{description2?.length ?? 0}/500</span>
              </div>
              <button
                className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95 mt-4"
                onClick={() => resolverAndTerminate()}
              >
                Procesar Reembolso/Penalización
              </button>
            </div>
          )}

          {detailsView == "end" && (
            <div className="flex flex-col gap-4"></div>
          )}
          {detailsView == "chat_1" && (
            <div className="flex flex-col gap-6">
              {/* Encabezado con estado */}
              <div className="flex items-center justify-between">
                <span className="text-sm text-neutral-text font-medium">
                  Solicitud de reserva:
                </span>
                {/* <span className="px-3 py-1 bg-blue-100 text-primary text-xs font-medium rounded-full">
                  En curso
                </span> */}
              </div>

              {/* Nombre y foto del huésped */}
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-neutral-text">
                  {selectedConversation?.userIdOneNavigation?.name} {selectedConversation?.userIdOneNavigation?.lastName}
                </h3>
                <div className="size-14 rounded-full bg-neutral-bg overflow-hidden flex-shrink-0">
                  <img
                    src={
                      user?.id == selectedConversation?.userIdOne
                        ? selectedConversation?.userIdTwoNavigation?.photoLink
                        : selectedConversation?.userIdOneNavigation?.photoLink
                    }
                    alt="Perfil"
                    className="size-full object-cover"
                  />
                </div>
              </div>

              {/* Información de la reserva */}
              <div className="text-sm text-neutral-text space-y-1">
                <p className="font-medium">{selectedConversation?.listingRent?.name}</p>
                <p className="text-neutral-secondary">{selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.calculationDetails ?? ""}</p>
                <p className="text-neutral-secondary">{selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.amount} {selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.currencyCode}</p>
              </div>

              {/* Acerca de */}
              <div className="border-t border-neutral-border pt-4">
                <h4 className="text-base font-semibold text-neutral-text mb-3">
                  Acerca {selectedConversation?.userIdOneNavigation?.name} {selectedConversation?.userIdOneNavigation?.lastName}
                </h4>
                <div className="flex flex-col gap-2 text-sm">
                  <p className="text-neutral-text">
                    Valoración de {userProfile?.guestReviewCalification} en {userProfile?.countReviewsGuest} reseñas
                  </p>
                  <p className="text-neutral-text underline cursor-pointer">
                    Identidad verificada
                  </p>
                  <p className="text-neutral-secondary">
                    Se unió a JOM hace {userProfile?.timeInAssert}
                  </p>
                  <p className="text-neutral-secondary">
                    Vive en {userProfile?.city}, Bolivia
                  </p>
                  <p className="text-neutral-secondary">
                    Habla inglés, español y albanés
                  </p>
                  <p className="text-neutral-text underline cursor-pointer font-medium">
                    Muestra el perfil
                  </p>
                </div>
              </div>

              {/* Detalles de la reservación */}
              <div className="border-t border-neutral-border pt-4">
                <h4 className="text-base font-semibold text-neutral-text mb-3">
                  Detalles de la reservación
                </h4>
                <div className="flex flex-col gap-3 text-sm">
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1">
                      Huéspedes
                    </p>
                    <p className="text-neutral-text">1 adulto</p>
                  </div>
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                      Check-in
                    </p>
                    <p className="text-neutral-text">mié, 3 ene 2024</p>
                  </div>
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                      Check-out
                    </p>
                    <p className="text-neutral-text">mié, 31 ene 2024</p>
                  </div>
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                      Fecha de la reservación
                    </p>
                    <p className="text-neutral-text">mié, 31 ene 2024</p>
                  </div>
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                      Código de confirmación
                    </p>
                    <p className="text-neutral-text">HM4HJN9TAKB</p>
                  </div>
                  <div>
                    <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                      Política de cancelación
                    </p>
                    <p className="text-neutral-text">Moderada</p>
                  </div>
                </div>
              </div>

              {/* Sección de Pagos */}
              <div className="border-t border-neutral-border pt-6">
                {/* Pagado por el huésped */}
                <div className="mb-6">
                  <h4 className="text-base font-semibold text-neutral-text mb-4">
                    Pagado por el huésped
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-neutral-text">1 noche x 80,00 BOB</span>
                      <span className="text-neutral-text">80,00 BOB</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-neutral-text">Tarifa por servicio al huésped</span>
                      <span className="text-neutral-text">16,00 BOB</span>
                    </div>
                    <div className="flex justify-between font-semibold text-base pt-2 border-t border-neutral-border mt-2">
                      <span className="text-neutral-text">Total (BOB)</span>
                      <span className="text-neutral-text">96,00 BOB</span>
                    </div>
                  </div>
                </div>

                {/* Cobro recibido por el anfitrión */}
                <div className="border-t border-neutral-border pt-4 mb-6">
                  <h4 className="text-base font-semibold text-neutral-text mb-4">
                    Cobro recibido por el anfitrión
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-neutral-text">Tarifa de la habitación por 11 noches</span>
                      <span className="text-neutral-text">80,00 BOB</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-neutral-text">Tarifa por servicio para anfitriones (3,0 %)</span>
                      <span className="text-neutral-text">-3,00 BOB</span>
                    </div>
                    <div className="flex justify-between font-semibold text-base pt-2 border-t border-neutral-border mt-2">
                      <span className="text-neutral-text">Total (BOB)</span>
                      <span className="text-neutral-text">77,00 BOB</span>
                    </div>
                  </div>
                </div>

                {/* Historial de transacciones */}
                <button className="w-full flex items-center gap-2 py-3 border-t border-b border-neutral-border text-neutral-text hover:bg-neutral-bg transition-colors">
                  <span className="material-symbols-outlined text-[20px]">
                    receipt_long
                  </span>
                  <span className="text-sm font-medium">Historial de transacciones</span>
                </button>

                {/* Asistencia */}
                <div className="pt-6">

                  {/* Tarjeta de Gestión de Incidente */}
                  {selectedConversation?.tbComplaints?.length > 0 && (
                    <div className="mb-6 p-4 bg-[rgb(243,244,246)] border border-neutral-border rounded-xl">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="material-symbols-outlined text-primary text-[20px]">
                          warning
                        </span>
                        <h4 className="text-sm font-semibold text-neutral-text">
                          Gestión de Incidente
                        </h4>
                      </div>
                      <p className="text-xs text-neutral-secondary mb-4 leading-relaxed">
                        Como administrador, puedes iniciar una notificación oficial con la contraparte para mediar en este incidente.
                      </p>

                      <button
                        onClick={() => {
                          const guestId = selectedConversation?.booking?.userIdRenter;
                          const initiatorId = selectedConversation?.userIdOne;

                          let targetId = "";
                          let targetRole = "";
                          let targetName = "";

                          if (initiatorId === guestId) {
                            targetId = selectedConversation?.booking?.listingRent?.ownerUserId || "";
                            targetRole = "Anfitrión";
                            targetName = selectedConversation?.booking?.listingHostName || "Dueño de la propiedad";
                          } else {
                            targetId = guestId;
                            targetRole = "Huésped";

                            const guestFirstName = selectedConversation?.booking?.nameRenter || "";
                            const guestLastName = selectedConversation?.booking?.lastNameRenter || "";
                            targetName = `${guestFirstName} ${guestLastName}`.trim();
                          }

                          setSupportTargetId(targetId);
                          setSupportTargetRole(targetRole);
                          setSupportTargetName(targetName);
                          setShowSupportModal(true);
                        }}
                        className="w-full flex items-center justify-center gap-2 py-2.5 px-4 bg-primary text-white text-sm font-medium rounded-lg hover:bg-ui-primary-hover transition-colors active:scale-95 shadow-sm"
                      >
                        <span className="material-symbols-outlined text-[18px]">
                          chat_add_on
                        </span>
                        Notificar a la otra parte
                      </button>

                      {/* Botón para ir al otro chat relacionado al incidente */}
                      {/* {relatedChat && (
                        <button
                          onClick={() => openChat(relatedChat)}
                          className="w-full flex items-center justify-center gap-2 py-2.5 px-4 mt-3 bg-white border-2 border-primary text-primary text-sm font-bold rounded-lg hover:bg-neutral-bg transition-colors active:scale-95 shadow-sm"
                        >
                          <span className="material-symbols-outlined text-[18px]">
                            swap_horiz
                          </span>
                          Ir al chat con {
                            user?.id == relatedChat.userIdOne
                              ? relatedChat.userIdTwoNavigation?.name
                              : relatedChat.userIdOneNavigation?.name
                          }
                        </button>
                      )} */}
                    </div>
                  )}


                  <h4 className="text-base font-semibold text-neutral-text mb-4">
                    Asistencia
                  </h4>

                  {/* Opciones de asistencia */}
                  <div className="flex flex-col">

                    <button className="flex items-center justify-between py-3 text-left hover:bg-neutral-bg transition-colors border-t border-neutral-border">
                      <span className="text-sm text-neutral-text">
                        Denunciar a este huésped
                      </span>
                      <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                        chevron_right
                      </span>
                    </button>
                    <button className="flex items-center justify-between py-3 text-left hover:bg-neutral-bg transition-colors border-t border-b border-neutral-border">
                      <span className="text-sm text-neutral-text">
                        Visita el centro de ayuda
                      </span>
                      <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                        chevron_right
                      </span>
                    </button>
                  </div>
                </div>

                {/* Preguntas frecuentes */}
                <div className="pt-6">
                  <h4 className="text-base font-semibold text-neutral-text mb-4">
                    Preguntas frecuentes
                  </h4>

                  <div className="space-y-4">
                    {/* Pregunta 1 */}
                    <div className="pb-4 border-b border-neutral-border">
                      <h5 className="text-sm font-medium text-neutral-text mb-2">
                        Imprimir los detalles de cobro y recibos de las reservaciones
                      </h5>
                      <p className="text-xs text-neutral-secondary mb-2">
                        Podrás encontrar recibos individuales cuando accedes a tus reservaciones.
                      </p>
                      <button className="text-xs text-neutral-text underline font-medium">
                        Seguir leyendo
                      </button>
                    </div>

                    {/* Pregunta 2 */}
                    <div className="pb-4 border-b border-neutral-border">
                      <h5 className="text-sm font-medium text-neutral-text mb-2">
                        Reembolsa a tu huésped
                      </h5>
                      <p className="text-xs text-neutral-secondary mb-2">
                        El proceso para que los anfitriones envíen un reembolso a los huéspedes cambió si se gestiona durante la estadía, la experiencia o el servicio, o bien después del check-in...
                      </p>
                      <button className="text-xs text-neutral-text underline font-medium">
                        Seguir leyendo
                      </button>
                    </div>

                    {/* Pregunta 3 */}
                    <div>
                      <h5 className="text-sm font-medium text-neutral-text mb-2">
                        Cuánto tiempo tienes para dejar una reseña
                      </h5>
                      <p className="text-xs text-neutral-secondary mb-2">
                        Después de que termine tu estadía, tendrás un tiempo limitado para escribir una reseña...
                      </p>
                      <button className="text-xs text-neutral-text underline font-medium">
                        Seguir leyendo
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  </aside>
);

export default ReservationDetails;